import { BaseObject } from './BaseObject';

export class UsuarioModel extends BaseObject {
    email: string;
    username: string;
    password: string;
    aceptaTerminosCondiciones: boolean;

    //Data User
    mobileNumber: string;
    firstname: string;
    surname: string;
    birthDate: Date;
    gender: string;
    nationality: string;

    //Datos de facturación
    ruc: string;
    initials: string;
    direccion: string;

    nombre: string;
    bio: string;

    //Datos de facturación
    tieneCertificadoDigital: boolean;

    image: string;
    contrasenia: string;
    workPhoneNumber: string;

    usuarioAPP: boolean;

    planId: number;
    planIdTipoFirma: number;
    planAceptaTerminosCondiciones: boolean;
    sitioReferencia: string;
    
    //Recuperar password
    userValid: boolean;
    userCode: string;

    //Codigo Referido
    codigoReferido: string;
}